// import { useState, useEffect } from "react";

// const PORT = 11100;

// export default function useRDService() {
//     const [device, setDevice] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const callRD = (method, url, body = null) => {
//         return new Promise((resolve, reject) => {
//             const xhr = new XMLHttpRequest();

//             xhr.open(method, url, true);

//             if (
//                 method === "CAPTURE" ||
//                 method === "POST"
//             ) {
//                 xhr.setRequestHeader(
//                     "Content-Type",
//                     "text/xml"
//                 );
//             }

//             xhr.onload = () => resolve(xhr.responseText);
//             xhr.onerror = () => reject(
//                 new Error("RD Service Error")
//             );

//             xhr.send(body);
//         });
//     };


//     const detectDevice = async () => {
//         try {

//             // try http detection first
//             let res;

//             try {
//                 res = await callRD(
//                     "RDSERVICE",
//                     `https://127.0.0.1:${PORT}`
//                 );
//             } catch {
//                 res = await callRD(
//                     "RDSERVICE",
//                     `http://127.0.0.1:${PORT}`
//                 );
//             }

//             const parser = new DOMParser();

//             const xml = parser.parseFromString(
//                 res,
//                 "text/xml"
//             );

//             const status =
//                 xml.querySelector("RDService")
//                     ?.getAttribute("status");

//             const info =
//                 xml.querySelector("RDService")
//                     ?.getAttribute("info");

//             if (status !== "READY") {
//                 setDevice(null);
//                 return null;
//             }

//             let name = "UNKNOWN";

//             if (/mantra/i.test(info)) {
//                 name = "MANTRA";
//             }
//             else if (/morpho/i.test(info)) {
//                 name = "MORPHO";
//             }
//             else if (/idemia/i.test(info)) {
//                 name = "MORPHO(IDEMIA)";
//             }

//             setDevice(name);

//             return name;

//         } catch {
//             setDevice(null);
//             throw new Error(
//                 "RD Service not running"
//             );
//         }
//     };

//     useEffect(() => {
//         detectDevice().catch(() => { });
//     }, []);



//     const captureFingerprint = async (
//         wadhValue = ""
//     ) => {
//         setLoading(true);

//         try {

//             let currentDevice = device;

//             if (!currentDevice) {
//                 currentDevice =
//                     await detectDevice();
//             }

//             if (!currentDevice) {
//                 throw new Error(
//                     "Device not detected"
//                 );
//             }

//             let pidXML = "";
//             let captureUrl = "";
//             let captureMethod = "CAPTURE";


//             // MANTRA
//             if (currentDevice === "MANTRA") {

//                 pidXML = `<?xml version="1.0"?>
// <PidOptions ver="1.0">
// <Opts
// fCount="1"
// fType="2"
// iCount="0"
// pCount="0"
// pgCount="2"
// format="0"
// pidVer="2.0"
// timeout="10000"
// pTimeout="20000"
// posh="UNKNOWN"
// env="P"
// wadh="${wadhValue}"
// />
// <CustOpts>
// <Param
// name="mantrakey"
// value=""
// />
// </CustOpts>
// </PidOptions>`;

//                 // ✅ your actual mantra endpoint
//                 captureUrl =
//                     `https://127.0.0.1:${PORT}/rd/capture`;

//                 captureMethod = "CAPTURE";
//             }


//             // MORPHO existing unchanged
//             else {



//                 pidXML = `<PidOptions ver="1.0"><Opts env="P" fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="${wadhValue}" posh=""/></PidOptions>`;

//                 captureUrl =
//                     `https://127.0.0.1:${PORT}/capture`;

//                 captureMethod = "CAPTURE";
//             }

//             const res = await callRD(
//                 captureMethod,
//                 captureUrl,
//                 pidXML
//             );

//             return res;

//         }
//         finally {
//             setLoading(false);
//         }
//     };


//     return {
//         device,
//         loading,
//         captureFingerprint
//     };

// }


import { useState, useEffect } from "react";

// Array of ports to scan
const PORTS = [11100, 11101, 11102, 11103, 11104, 11105];

export default function useRDService() {
    const [device, setDevice] = useState(null);
    const [activePort, setActivePort] = useState(null); // Track which port actually responded
    const [loading, setLoading] = useState(false);

    const callRD = (method, url, body = null) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open(method, url, true);

            if (method === "CAPTURE" || method === "POST") {
                xhr.setRequestHeader("Content-Type", "text/xml");
            }

            xhr.onload = () => resolve(xhr.responseText);
            xhr.onerror = () => reject(new Error("RD Service Error"));

            xhr.send(body);
        });
    };

    // Helper function to test a single port
    const testPort = async (port) => {
        let res;
        try {
            // try https detection first
            res = await callRD("RDSERVICE", `https://127.0.0.1:${port}`);
        } catch {
            // fallback to http; if this fails, it will reject the promise
            res = await callRD("RDSERVICE", `http://127.0.0.1:${port}`);
        }

        const parser = new DOMParser();
        const xml = parser.parseFromString(res, "text/xml");
        const rdService = xml.querySelector("RDService");

        if (!rdService || rdService.getAttribute("status") !== "READY") {
            throw new Error(`Device not ready on port ${port}`);
        }

        const info = rdService.getAttribute("info");
        let name = "UNKNOWN";

        if (/mantra/i.test(info)) {
            name = "MANTRA";
        } else if (/morpho/i.test(info)) {
            name = "MORPHO";
        } else if (/idemia/i.test(info)) {
            name = "MORPHO(IDEMIA)";
        }

        // Return both the detected device name and the port it was found on
        return { name, port };
    };

    const detectDevice = async () => {
        try {
            // Map over the PORTS array to create an array of promises
            const promises = PORTS.map(port => testPort(port));
            
            // Promise.any resolves as soon as ANY of the ports return a successful match
            const result = await Promise.any(promises);

            setDevice(result.name);
            setActivePort(result.port); // Save the successful port to state

            return result;
        } catch {
            setDevice(null);
            setActivePort(null);
            throw new Error("RD Service not running on any scanned port");
        }
    };

    useEffect(() => {
        detectDevice().catch(() => {});
    }, []);

    const captureFingerprint = async (wadhValue = "", otpValue = "") => {
        setLoading(true);

        try {
            let currentDevice = device;
            let currentPort = activePort;

            // If we don't have a device or port yet, force a detection
            if (!currentDevice || !currentPort) {
                const result = await detectDevice();
                currentDevice = result.name;
                currentPort = result.port;
            }

            if (!currentDevice || !currentPort) {
                throw new Error("Device not detected");
            }

            let pidXML = "";
            let captureUrl = "";
            let captureMethod = "CAPTURE";

            // MANTRA
            if (currentDevice === "MANTRA") {
                pidXML = `<?xml version="1.0"?>
<PidOptions ver="1.0">
<Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="2" format="0" pidVer="2.0" timeout="10000" pTimeout="20000" posh="UNKNOWN" env="P" wadh="${wadhValue}" otp="${otpValue}"/>
<CustOpts><Param name="mantrakey" value=""/></CustOpts>
</PidOptions>`;

                // Use currentPort dynamically
                captureUrl = `https://127.0.0.1:${currentPort}/rd/capture`;
                captureMethod = "CAPTURE";
            }
            // MORPHO
            else {
                pidXML = `<PidOptions ver="1.0"><Opts env="P" fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="${otpValue}" wadh="${wadhValue}" posh=""/></PidOptions>`;

                // Use currentPort dynamically
                captureUrl = `https://127.0.0.1:${currentPort}/capture`;
                captureMethod = "CAPTURE";
            }

            const res = await callRD(captureMethod, captureUrl, pidXML);
            return res;

        } finally {
            setLoading(false);
        }
    };

    return {
        device,
        activePort,
        loading,
        captureFingerprint
    };
}